const LOCATION_ID =
  /^\/locations\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:\/|$)/i;

export function locationIdFromPath(pathname: string): string | null {
  return pathname.match(LOCATION_ID)?.[1] ?? null;
}

export function locationPath(locationId: string, section = ''): string {
  const suffix = section.replace(/^\//, '');
  return suffix ? `/locations/${locationId}/${suffix}` : `/locations/${locationId}`;
}

export function locationSiblingPath(pathname: string, fromId: string, toId: string): string {
  const prefix = `/locations/${fromId}`;
  const rest = pathname.startsWith(prefix) ? pathname.slice(prefix.length) : '';
  const parts = rest.split('/').filter(Boolean);
  const last = parts[parts.length - 1];
  if (last && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(last)) {
    parts.pop();
  }
  return locationPath(toId, parts.join('/'));
}
